import { SettingsContext } from '@contexts/SettingsContext';
import { useContext } from 'react';

export const useSettings = () => {
  const settings = useContext(SettingsContext);

  return settings;
};
